import { useNavigate } from "react-router-dom";
import Styles from "./LandingPage.module.css";
import { PiInstagramLogoBold } from "react-icons/pi";
import { RiFacebookFill } from "react-icons/ri";
import AccordionItem from "../../Components/AccordianItem";
import { FAQS_TLAT } from "../../Model/FaqModel";
import { useEffect, useRef, useState } from "react";
import Testimonial from "../Home/Testimonial";
import { Testimonials_Model } from "../../Model/HomeModel";
import Loading from "../../Components/Loading";
import { FaMapMarkedAlt } from "react-icons/fa";
import { IoHomeOutline } from "react-icons/io5";
import { IoIosCall, IoIosCloseCircle } from "react-icons/io";
import { DetailsFormJSon2, ValidatorForm3 } from "./LandingPageModel";
import { useDispatch, useSelector } from "react-redux";
import { Test_Book } from "../../Action/ContactAction";
import "./Landing.css";
import {
  TEST_BOOKING_FAILED,
  TEST_BOOKING_RESET,
} from "../../Constant/ContactConstant";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet";

export default function LandingPage3() {
  const Navigate = useNavigate();
  const [active, setActive] = useState(null);
  const [DetailsForm, setDetailsForm] = useState(DetailsFormJSon2);
  const TestmonialRef = useRef();
  const ScrollRef = useRef();
  const dispatch = useDispatch();
  const { loading, success, error, Score } = useSelector(
    (s) => s.Test_Book_Reducer
  );
  const [index, setIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("fadeInUp");
  const Heading = [1, 2, 3];
  const [createSec, setcreateSec] = useState(false);
  const [Auth, setAuth] = useState({
    loading: false,
    success: false,
    error: false,
  });

  useEffect(() => {
    const intervalId = setInterval(
      () => {
        setAnimationClass("");
        setIndex((index) => (index + 1) % Heading.length);
        setAnimationClass("fadeInUp");
      },
      5000 // every 5 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  const handleToggle = (index) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };

  const handleChange = (e) => {
    if (e.target.name == "PhoneNo" && e.target.value.includes(" ")) {
    } else {
      setDetailsForm({ ...DetailsForm, [e.target.name]: e.target.value });
    }
  };

  const handleCancel = () => {
    setcreateSec(false);
    setDetailsForm({ ...DetailsFormJSon2 });
  };

  const Scroll = () => {
    setcreateSec(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const Validate = ValidatorForm3(DetailsForm);
    if (Validate == "success") {
      dispatch(
        Test_Book(
          { ...DetailsForm, url: window.location.href },
          "/psychometric/TLAT/createId"
        )
      );
    } else {
      dispatch({ type: TEST_BOOKING_FAILED, payload: Validate });
    }
  };

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setcreateSec(false);
        setDetailsForm({ ...DetailsFormJSon2 });
        dispatch({ type: TEST_BOOKING_RESET });
        Navigate(`/T-LAT-acknowledge/${success}`);
      }, 3000);
    }
  }, [success, dispatch]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     document.getElementById("stat1").classList.add("show");
  //     document.getElementById("JoinStat1").classList.add("show");
  //   }, 500);

  //   setTimeout(() => {
  //     document.getElementById("stat2").classList.add("show");
  //     document.getElementById("JoinStat2").classList.add("show");
  //   }, 1500);

  //   setTimeout(() => {
  //     document.getElementById("stat3").classList.add("show");
  //     document.getElementById("JoinStat3").classList.add("show");
  //   }, 2500);

  //   setTimeout(() => {
  //     document.getElementById("JoinStat4").classList.add("show");
  //   }, 3000);
  // }, []);

  return (
    <>
      <Helmet>
        <meta
          name="title"
          content="Book Reality Test for IELTS & PTE | TRT | Testifyi Language Assessment Test"
        />
        <meta
          name="description"
          content="Discover your IELTS/PTE level in a real test environment by Testifyi. Perfect for students aspiring to study abroad! Affordable: At just ₹99."
        />
        <meta
          name="keywords"
          content="Book Reality Test for IELTS & PTE, IELTS Reality Test, PTE Reality Test, IELTS & PTE reality test, testifyi reality test, TRT test"
        />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="5 days" />
        <meta name="author" content="Testifyi" />
        <title>
          Book Language Assessment Test for IELTS & PTE | TRT | Testifyi
          Language Assessment Test{" "}
        </title>
        <script type="application/ld+json">
          {`{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What is TRT: Testifyi Reality Test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "TRT is a specially designed mock IELTS/PTE test that allows students to: Experience the real IELTS/PTE exam environment. Assess their current skill level. Receive detailed feedback to improve performance in Listening, Reading, Writing, and Speaking"
    }
  },{
    "@type": "Question",
    "name": "What is the cost of the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The test is priced at just ₹99—a highly affordable opportunity to experience a real exam-like environment."
    }
  },{
    "@type": "Question",
    "name": "When and where will the event be conducted?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The event is scheduled for January 18, 2025, at Nehru Place, Delhi, from 10:00 AM to 5:00 PM."
    }
  },{
    "@type": "Question",
    "name": "What documents should I bring along?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Please bring the following: A valid photo ID (Aadhaar card, passport, or student ID). Your registration confirmation email or message. Basic stationery like pens, pencils, and erasers."
    }
  },{
    "@type": "Question",
    "name": "What is included in the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The test includes all four sections of the IELTS/PTE exam: Listening, Reading, Writing, and Speaking. You’ll get a complete experience of the actual test format."
    }
  },{
    "@type": "Question",
    "name": "When will my Speaking module test be conducted?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The Speaking test will be conducted on the same day as the event. Specific time slots will be assigned 2 days prior to the test day."
    }
  },{
    "@type": "Question",
    "name": "Will I be notified about my Speaking test time slot?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, your Speaking test time slot will be shared with you 2 days prior to the test day."
    }
  },{
    "@type": "Question",
    "name": "Who can participate in this event?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "This test is ideal for students preparing for IELTS/PTE, whether you're a beginner or looking to refine your skills before the actual exam."
    }
  },{
    "@type": "Question",
    "name": "Will I receive feedback on my performance?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, our IELTS/PTE experts will provide personalized feedback after the test, helping you understand your strengths and areas for improvement."
    }
  },{
    "@type": "Question",
    "name": "How can I register for the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Click the [Register Now for ₹99] button, fill in your details, and a Testifyi coordinator will reach out to help you secure your spot."
    }
  },{
    "@type": "Question",
    "name": "What happens if I miss the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Unfortunately, the fee is non-refundable. However, you may contact us to explore any future test opportunities."
    }
  }]
}`}
        </script>
      </Helmet>

      {/* Header  start*/}
      {loading ? <Loading /> : ""}
      <header>
        <div className={Styles.Header}>
          <div>
            <img
              onClick={() => Navigate("/")}
              src="/assets/image/Logos/Testify_White_Logo.svg"
              alt="logo"
            />
          </div>
          {/* <div>
            <button className={Styles.ActionBtn}>Book</button>
          </div> */}
        </div>
      </header>
      {/* Header end */}

      {/* Banner form Section start */}
      <section className={Styles.Margin_new}>
        <div className={Styles.BannerTop}>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent:
                  window.innerWidth <= 480 ? "flex-start" : "space-between",
                flexDirection: window.innerWidth <= 480 ? "column" : "row",
                // alignItems: "center",
              }}
            ></div>
            {/* <div id="container2">
              {index == 0 ? (
                <AnimatePresence mode="wait">
                  <motion.div
                    key={index}
                    className="section"
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div
                      id="BannerText"
                      className={`HeadingBanner ${animationClass}`}
                    >
                      <h2>
                        Experience{" "}
                        <span style={{ color: "#0b3eff" }}>IELTS/PTE</span>{" "}
                        Before the Real{" "}
                        {window.innerWidth <= 480 ? " " : <br />}
                        Exam — For Just{" "}
                        <span style={{ color: "#0b3eff" }}>₹99/-</span>{" "}
                      </h2>

                      <h4>
                        Discover your IELTS/PTE level in a real test
                        environment. Perfect for students aspiring to study
                        abroad!
                      </h4>
                    </div>
                  </motion.div>
                </AnimatePresence>
              ) : index == 1 ? (
                <AnimatePresence mode="wait">
                  <motion.div
                    key={index}
                    className="section"
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div
                      id="BannerText"
                      className={`HeadingBanner hdr2 ${animationClass}`}
                    >
                      <h2>
                        <span
                          style={{
                            color: "#0b3eff",
                          }}
                        >
                          IELTS
                        </span>{" "}
                        <span>REALITY TEST</span>
                      </h2>

                      <h4>
                        Get the Full IELTS Exam Experience — Practice in a
                        Real-World Setting and Boost Your Success!
                      </h4>
                    </div>
                  </motion.div>
                </AnimatePresence>
              ) : (
                <AnimatePresence mode="wait">
                  <motion.div
                    key={index}
                    className="section"
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div
                      id="BannerText"
                      className={`HeadingBanner hdr2 ${animationClass}`}
                    >
                      <h2>
                        <span
                          style={{
                            color: "#0b3eff",
                          }}
                        >
                          PTE
                        </span>{" "}
                        <span>REALITY TEST</span>
                        
                      </h2>

                      <h4>
                        Experience the Real PTE Exam Before the Big Day —
                        Format, Timing, and Challenges Included!
                      </h4>
                    </div>
                  </motion.div>
                </AnimatePresence>
              )}
            </div> */}

            <div>
              <img src="/assets/image/Asset_5.png" alt="landing_logo" />
            </div>

            {/* <div>
              <button className={Styles.ActionBtn} onClick={() => Scroll()}>
                Take A Test
              </button>
            </div> */}
          </div>
          {/* Form Details Start */}
          <div ref={ScrollRef}>
            <AnimatePresence mode="wait">
              <motion.div
                className="section"
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.5 }}
              >
                <div>
                  <div className={Styles.DetailsForm}>
                    <div>
                      <h4>Register Now for T-LAT: Language Assessment Test!</h4>
                    </div>
                    <div>
                      <input
                        type="text"
                        placeholder="First Name*"
                        name="First_Name"
                        value={DetailsForm.First_Name}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <input
                        type="text"
                        placeholder="Last Name*"
                        name="Last_Name"
                        value={DetailsForm.Last_Name}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <input
                        type="email"
                        placeholder="Email*"
                        name="EmailAddress"
                        value={DetailsForm.EmailAddress}
                        onChange={handleChange}
                      />
                    </div>

                    {/* <div>
                      <input
                        type="text"
                        placeholder="city*"
                        name="city"
                        value={DetailsForm.city}
                        onChange={handleChange}
                      />
                    </div> */}

                    <div className={Styles.MobilePhone}>
                      <div>
                        <select>
                          <option>91</option>
                        </select>
                      </div>
                      <div>
                        <input
                          type="number"
                          placeholder="Phone Number*"
                          name="PhoneNo"
                          value={DetailsForm.PhoneNo}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* <div className={Styles.Venue}>
                      <div>
                        <select
                          name="location"
                          value={DetailsForm.location}
                          onChange={handleChange}
                        >
                          <option value="">Select Location</option>
                          <option value="Delhi">Delhi</option>
                          <option value="Chandigarh">Chandigarh</option>
                        </select>
                      </div>
                      <div>
                        <select
                          name="timeSlot"
                          value={DetailsForm.timeSlot}
                          onChange={handleChange}
                        >
                          <option value="">Select Time Slot</option>
                          <option value="10:30 am to 1:30 pm">
                            10:30 am to 1:30 pm
                          </option>
                          <option value="2:00 pm to 5:00 pm">
                            2:00 pm to 5:00 pm
                          </option>
                        </select>
                      </div>
                    </div> */}

                    <div>
                      {error ? (
                        <p style={{ color: "red" }}> {error}</p>
                      ) : success ? (
                        <p style={{ color: "green" }}>
                          {
                            "Please Wait — we are redirecting you to the TLAT test!"
                          }
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <button
                      style={{ marginTop: "15px" }}
                      className={Styles.ActionBtn2}
                      onClick={handleSubmit}
                    >
                      {loading ? "Loading..." : "SUBMIT"}
                    </button>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Form Details end */}
        </div>
      </section>
      {/* Banner form Section end */}

      {/* Video Section Start */}

      {/* <section>
        <AnimatePresence mode="wait">
          <motion.div
            className="section"
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5 }}
          >
            <div className={Styles.Margin_new}>
              <div className="trust-section">
                <div>
                  <h1 className={Styles.Font_Rajdhani}>
                    Trusted by
                    <span style={{ color: "#0b3eff" }}> Thousands</span> of Test
                    Takers
                  </h1>
                  <p>
                    Over <strong>300+ Tests Conducted</strong> and{" "}
                    <strong>15000+ Test Takers</strong>. Join us to experience
                    the real test environment!
                  </p>
                </div>
                <div className="trust-stats">
                  <div className="stat-box fade-animation show" id="stat1">
                    <h3>300+</h3>
                    <span>Tests Conducted</span>
                  </div>
                  <div className="stat-box fade-animation show" id="stat2">
                    <h3>15000+</h3>
                    <span>Test Takers</span>
                  </div>
                  <div className="stat-box fade-animation show" id="stat3">
                    <h3>100%</h3>
                    <span>Satisfied Students</span>
                  </div>
                </div>
              </div>
              <div className={Styles.VideoSection}>
                <video
                  preload="auto"
                  autobuffer
                  muted
                  width="100%"
                  height="100%"
                  autoPlay
                  loop
                  playsInline
                >
                  <source src="/assets/image/web-vd.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </section> */}

      {/* Video section End */}

      {/* why Join us start */}

      <section>
        <div className={Styles.Margin_new}>
          <div className={Styles.Section_12}>
            <div>
              <h1 className={Styles.Font_Rajdhani}>
                What is T-LAT?(
                <span style={{ color: "#0b3eff" }}> Testifyi</span> Language
                Assessment Test)?
              </h1>
              <p>
                T-LAT is an innovative testing system that lets you assess your
                English language proficiency quickly and accurately. Powered by
                a unique AI grading technique, T-LAT is the ideal first step
                towards your language journey!
              </p>
            </div>

            {/* <div className="trt-grid">
              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h3>Real Test Environment</h3>
                <p>
                  Experience the real IELTS/PTE test environment to reduce
                  test-day anxiety.
                </p>
              </div>
              <div className="trt-card fade-animation1 show" id="JoinStat2">
                <div className="icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3>Skill Assessment</h3>
                <p>
                  Understand your current skill level with a detailed
                  performance analysis.
                </p>
              </div>
              <div className="trt-card fade-animation1 show" id="JoinStat3">
                <div className="icon">
                  <i className="fas fa-lightbulb"></i>
                </div>
                <h3>Insights & Feedback</h3>
                <p>
                  Receive expert insights into areas of improvement to maximize
                  your score.
                </p>
              </div>
              <div className="trt-card fade-animation1 show" id="JoinStat4">
                <div className="icon">
                  <i className="fas fa-book-open"></i>
                </div>
                <h3>All IELTS/PTE Sections</h3>
                <p>
                  Prepare for Listening, Reading, Writing, and Speaking—just
                  like the real exam!
                </p>
              </div>
            </div>

            <div className="trt-cta">
              <button className={Styles.ActionBtn} onClick={() => Scroll()}>
                Sign Up Today—Limited Seats Available
              </button>
            </div> */}
          </div>
        </div>
      </section>

      {/* why Join us end */}

      {/* why Join us start */}
      <section>
        <div className={Styles.Margin_new}>
          <div className={Styles.Section_12}>
            <div>
              <h1 className={Styles.Font_Rajdhani}>
                Why Take
                <span style={{ color: "#0b3eff" }}> T-LAT </span> Test?
              </h1>
              <p>
                Whether you are fresh out of college, aspiring to crack IELTS
                and go abroad, or a working professional simply curious about
                how strong your command on English is, T-LAT is the perfect tool
                for you. With meticulously designed questions that test a wide
                range of language skills in just under 15 minutes, it doesn’t
                get any easier to assess your English language proficiency.
              </p>
            </div>

            <div className="trt-grid">
              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-clock"></i>
                </div>

                <h3>Quick and Easy</h3>
                <p>
                  <strong>15 minutes</strong>, easy-to-follow{" "}
                  <strong>MCQ type questions</strong>.
                </p>
              </div>

              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-user-tie"></i>
                </div>

                <h3>Expertly Designed</h3>
                <p>
                  <strong>Meticulously created by language experts</strong> to
                  ensure accuracy.
                </p>
              </div>

              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-check-circle"></i>
                </div>

                <h3>Instant Results</h3>
                <p>
                  <strong>Get your results immediately</strong> after completing
                  the test.
                </p>
              </div>

              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-robot"></i>
                </div>

                <h3>AI Powered</h3>
                <p>
                  <strong>Advanced AI-driven evaluation</strong> for precise
                  assessment.
                </p>
              </div>

              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-graduation-cap"></i>
                </div>

                <h3>Ideal for IELTS/PTE/Duolingo</h3>
                <p>
                  The <strong>perfect pre-assessment</strong> for language test
                  aspirants.
                </p>
              </div>

              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-lightbulb"></i>
                </div>

                <h3>Comprehensive Skill Check</h3>
                <p>
                  <strong>Evaluates all language aspects</strong> for a complete
                  proficiency test.
                </p>
              </div>

              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fa fa-search-plus"></i>
                </div>

                <h3>Identify Weaknesses</h3>
                <p>
                  <strong>Pinpoint areas of improvement</strong> and work on
                  them effectively.
                </p>
              </div>

              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-trophy"></i>
                </div>

                <h3>Highlight Your Strengths</h3>
                <p>
                  <strong>Recognize your strong skills</strong> and refine them
                  further.
                </p>
              </div>
            </div>

            {/* <div className="trt-grid">
              <div className="trt-card fade-animation1 show" id="JoinStat1">
                <div className="icon">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h3>Real Test Environment</h3>
                <p>
                  Experience the real IELTS/PTE test environment to reduce
                  test-day anxiety.
                </p>
              </div>
              <div className="trt-card fade-animation1 show" id="JoinStat2">
                <div className="icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3>Skill Assessment</h3>
                <p>
                  Understand your current skill level with a detailed
                  performance analysis.
                </p>
              </div>
              <div className="trt-card fade-animation1 show" id="JoinStat3">
                <div className="icon">
                  <i className="fas fa-lightbulb"></i>
                </div>
                <h3>Insights & Feedback</h3>
                <p>
                  Receive expert insights into areas of improvement to maximize
                  your score.
                </p>
              </div>
              <div className="trt-card fade-animation1 show" id="JoinStat4">
                <div className="icon">
                  <i className="fas fa-book-open"></i>
                </div>
                <h3>All IELTS/PTE Sections</h3>
                <p>
                  Prepare for Listening, Reading, Writing, and Speaking—just
                  like the real exam!
                </p>
              </div>
            </div> */}
            <div className="trt-cta">
              <button className={Styles.ActionBtn}>
                Sign Up Today—Limited Seats Available
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* why Join us end */}

      <section>
        <div className={Styles.Margin_new}>
          <div className={Styles.Section_12}>
            <div>
              <h1 className={Styles.Font_Rajdhani}>
                How
                <span style={{ color: "#0b3eff" }}> T-LAT </span> Work
              </h1>
              <p>
                Understand the step-by-step process of the T-LAT test—from
                structure to scoring.
              </p>
            </div>
            <div className="Timeline_Webnier">
              <div className="timeline-container">
                <div className="timeline">
                  <div className="timeline-item">
                    <div className="timeline-pointer">1</div>
                    <div className="timeline-content">
                      {/* <div className="time">00 mins - 15 mins</div> */}
                      <h3>📝 3 Sets of 10 Questions</h3>
                      <p>
                        T-LAT guides you through 3 sets of 10 questions each,
                        making a total of 30 questions. The difficulty increases
                        with each set to cover{" "}
                        <b>
                          grammar, syntax, vocabulary, collocation, and more
                        </b>
                        .
                      </p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-pointer">2</div>
                    <div className="timeline-content">
                      {/* <div className="time">15 mins - 30 mins</div>
                       */}
                      <h3>📈 Increasing Marks</h3>
                      <p>
                        - Set 1 (Q1-10): 1 mark each
                        <br />
                        - Set 2 (Q11-20): 2 marks each
                        <br />- Set 3 (Q21-30): 3 marks each
                      </p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-pointer">3</div>
                    <div className="timeline-content">
                      {/* <div className="time">30 mins - 45 mins</div>
                       */}
                      <h3>⏱️ Timed Test</h3>
                      <p>
                        You have 15 minutes to complete the 30 multiple-choice
                        questions. A timer is displayed on the right and
                        navigation tabs at the bottom let you move between
                        questions.
                      </p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-pointer">4</div>
                    <div className="timeline-content">
                      {/* <div className="time">45 mins - 60 mins</div> */}
                      <h3>✅ Instant Results</h3>
                      <p>
                        Once you submit, the AI scorer shows your score out of
                        60 immediately. You can review your answers and see
                        which ones you missed.
                      </p>
                    </div>
                  </div>
                  {/* 
                  <div className="timeline-item">
                    <div className="timeline-pointer">5</div>
                    <div className="timeline-content">
                      <div className="time">60 mins - 75 mins</div>
                      <h3>Time Management Hacks</h3>
                      <p>
                        Advanced time management techniques for all sections,
                        with real-life scenarios and practical tools to optimize
                        performance.
                      </p>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-pointer">6</div>
                    <div className="timeline-content">
                      <div className="time">75 mins - 90 mins</div>
                      <h3>Real Student Success Stories</h3>
                      <p>
                        See how students improved their scores using these
                        techniques. Gain motivation and clarity for your own
                        test journey.
                      </p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* <div className={Styles.Why_Should_Section}>
                    <div className={Styles.Why_Sub_1}>
                      <div>
                        <i className="fas fa-chalkboard-teacher"></i>
                      </div>
                      <div>
                        <h3>Real Test Experience</h3>
                        <p>
                          Feel the pressure and format of an actual IELTS/PTE test.
                        </p>
                      </div>
                    </div>
      
                    <div className={Styles.Why_Sub_2}>
                      <div>
                        <h3>Affordable Fee</h3>
                        <p>At just ₹99, it's an unmissable opportunity.</p>
                      </div>
                      <div>
                        <i className="fas fa-wallet"></i>
                      </div>
                    </div>
      
                    <div className={Styles.Why_Sub_1}>
                      <div>
                        <i className="fas fa-chart-line"></i>
                      </div>
                      <div>
                        <h3>Skill Analysis</h3>
                        <p>Know where you stand and what to improve.</p>
                      </div>
                    </div>
      
                    <div className={Styles.Why_Sub_2}>
                      <div>
                        <h3>Expert Feedback</h3>
                        <p>Personalized insights from IELTS/PTE experts.</p>
                      </div>
                      <div>
                        <i className="fas fa-user-check"></i>
                      </div>
                    </div>
                  </div> */}
            {/* <div className="trt-cta">
                    <button className={Styles.ActionBtn}>
                      Sign Up Today—Limited Seats Available
                    </button>
                  </div> */}
          </div>
        </div>
      </section>

      <section>
        <div className={Styles.Margin_new}>
          <div className={Styles.Section_12}>
            <div>
              <h1 className={Styles.Font_Rajdhani}>
                T-LAT
                <span style={{ color: "#0b3eff" }}> Scoring </span> System
              </h1>
              {/* <p>
                Whether you are fresh out of college, aspiring to crack IELTS
                and go abroad, or a working professional simply curious about
                how strong your command on English is, T-LAT is the perfect tool
                for you. With meticulously designed questions that test a wide
                range of language skills in just under 15 minutes, it doesn’t
                get any easier to assess your English language proficiency.
              </p> */}
            </div>
            <div className="Pricing_Table">
              <table>
                <tr>
                  <th>Feature</th>
                  <th style={{ border: "none" }}>T-LAT</th>
                  <th style={{ border: "none", padding: "0" }}>V/S</th>
                  <th style={{ border: "none" }}>TRT</th>
                </tr>
                <tr>
                  <td className="feature-col">Cost</td>
                  <td style={{ border: "none" }}>
                    Affordable (No Cost - <b>Free </b>)
                  </td>
                  <td
                    style={{ border: "none", fontSize: "0", padding: "0" }}
                  ></td>
                  <td style={{ border: "none" }}>Expensive (₹15,000+)</td>
                </tr>
                <tr>
                  <td className="feature-col">Purpose</td>
                  <td style={{ border: "none" }}>Skill Check & Practice</td>
                  <td style={{ border: "none", fontSize: "0" }}></td>
                  <td style={{ border: "none" }}>Real Exam Simulation</td>
                </tr>
                <tr>
                  <td className="feature-col">Test Type</td>
                  <td style={{ border: "none" }}>Mock Proficiency Test</td>
                  <td style={{ border: "none", fontSize: "0" }}></td>
                  <td style={{ border: "none" }}>Full-Length Mock Exam</td>
                </tr>
                <tr>
                  <td className="feature-col">Time Required</td>
                  <td style={{ border: "none" }}>15 Minutes</td>
                  <td style={{ border: "none", fontSize: "0" }}></td>
                  <td style={{ border: "none" }}>2-3 Hours</td>
                </tr>
                <tr>
                  <td className="feature-col">Result Analysis</td>
                  <td style={{ border: "none" }}>Instant Feedback</td>
                  <td style={{ border: "none", fontSize: "0" }}></td>
                  <td style={{ border: "none" }}>Detailed Report</td>
                </tr>
              </table>
            </div>

            {/* <div className={Styles.Why_Should_Section}>
              <div className={Styles.Why_Sub_1}>
                <div>
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <div>
                 
                  <p>
                    Quick and Easy- 15 minutes, easy to follow MCQ type
                    questions
                  </p>
                </div>
              </div>

              <div className={Styles.Why_Sub_2}>
                <div>
                
                  <p>Meticulously designed by experts</p>
                </div>
                <div>
                  <i className="fas fa-wallet"></i>
                </div>
              </div>

              <div className={Styles.Why_Sub_1}>
                <div>
                  <i className="fas fa-chart-line"></i>
                </div>
                <div>
                  <h3>Skill Analysis</h3>
                  <p>Know where you stand and what to improve.</p>
                </div>
              </div>

              <div className={Styles.Why_Sub_2}>
                <div>
                  <h3>Expert Feedback</h3>
                  <p>Personalized insights from IELTS/PTE experts.</p>
                </div>
                <div>
                  <i className="fas fa-user-check"></i>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Event Details css start T-LAT Scoring System */}

      {/* <section>
        <div className={Styles.Margin_new}>
          <div className={Styles.Section_12}>
            <div>
              <h1 className={Styles.Font_Rajdhani}>
                Testify Reality
                <span style={{ color: "#0b3eff" }}> Test Event </span>Schedule
              </h1>
              <p></p>
            </div>
            <div className={Styles.EventDetails}>
              <div>
                <h4>Delhi</h4>
                <p className={Styles.Date}>
                  <span style={{ color: "#0b3eff" }}>
                    <FaCalendarAlt />
                  </span>{" "}
                  <span>
                    {" "}
                    18<sup>th</sup> JAN 2025 (Saturday)
                  </span>
                </p>
                <div className={Styles.Slots}>
                  <div className={Styles.Slot}>
                    <h3>Slot-1</h3>
                    <p>10:30 AM to 1:30 PM</p>
                  </div>
                  <div className={Styles.Slot}>
                    <h3>Slot-2</h3>
                    <p>2:00 PM to 5:00 PM</p>
                  </div>
                </div>
                <p className={Styles.location}>
                  <span style={{ color: "#0b3eff" }}>
                    <FaMapMarkerAlt />
                  </span>{" "}
                  1409-1412, 14th Floor, 38, Ansal Tower, Nehru Place, New
                  Delhi, Delhi 110019
                </p>
              </div>
              <div>
                <h4>Chandigarh</h4>
                <p className={Styles.Date}>
                  {" "}
                  <span style={{ color: "#0b3eff" }}>
                    <FaCalendarAlt />
                  </span>{" "}
                  <span>
                    1<sup>st</sup> FEB 2025 (Saturday){" "}
                  </span>
                </p>
                <div className={Styles.Slots}>
                  <div className={Styles.Slot}>
                    <h3>Slot-1</h3>
                    <p>10:30 AM to 1:30 PM</p>
                  </div>
                  <div className={Styles.Slot}>
                    <h3>Slot-2</h3>
                    <p>
                      <span></span> 2:00 PM to 5:00 PM
                    </p>
                  </div>
                </div>
                <p className={Styles.location}>
                  <span style={{ color: "#0b3eff" }}>
                    <FaMapMarkerAlt />
                  </span>{" "}
                  SCO 491, First Floor, above Airtel Store, sector 35C,
                  Chandigarh, 160022
                </p>
              </div>
            </div>
            <div className="trt-cta">
              <button className={Styles.ActionBtn} onClick={() => Scroll()}>
                Book Your Seat Now
              </button>
            </div>
          </div>
        </div>
      </section> */}

      <section>
        <div className={Styles.Margin_new}>
          <div className={Styles.Section_12}>
            <div>
              <h1 className={Styles.Font_Rajdhani}>
                Why You Should Take
                <span style={{ color: "#0b3eff" }}> T-LAT</span> ?
              </h1>
              {/* <p>Why You Should Take This Test.</p> */}
            </div>

            <div className={Styles.Why_Should_Section}>
              <div className={Styles.Why_Sub_1}>
                <div>
                  <i className="fas fa-graduation-cap icon"></i>
                </div>
                <div>
                  <h3>Planning to Study Abroad ?</h3>
                  <p>
                    T-LAT is a great tool for assessing your readiness for IELTS
                    or PTE, and for checking your overall language skills for
                    studying in an English-speaking country.
                  </p>
                </div>
              </div>

              <div className={Styles.Why_Sub_2}>
                <div>
                  <h3>Wish to Work or Settle Abroad ?</h3>
                  <p>
                    Take the first step towards working or settling in your
                    dream country with T-LAT! A quick assessment to check your
                    English skills.
                  </p>
                </div>
                <div>
                  <i className="fas fa-briefcase icon"></i>
                </div>
              </div>

              <div className={Styles.Why_Sub_1}>
                <div>
                  <i className="fas fa-clock icon"></i>
                </div>
                <div>
                  <h3>Falling Short of Time for a Full-Fledged Mock Test ?</h3>
                  <p>
                    Measure your progress in your IELTS/PTE prep journey within
                    15 minutes with T-LAT, a quick but efficient test.
                  </p>
                </div>
              </div>

              <div className={Styles.Why_Sub_2}>
                <div>
                  <h3>Willing to Improve English Language Skills ?</h3>
                  <p>
                    If you're trying to improve your General English, T-LAT is a
                    simple and quick way to find your strengths and weaknesses.
                  </p>
                </div>
                <div>
                  <i className="fas fa-language icon"></i>
                </div>
              </div>
              <div className={Styles.Why_Sub_1}>
                <div>
                  <i className="fas fa-pencil-alt icon"></i>
                </div>
                <div>
                  <h3>Looking to Fine-Tune Your English ?</h3>
                  <p>
                    If you're mostly confident in English but need to polish
                    certain skills, T-LAT will help you identify areas to focus
                    on.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="trt-cta">
                   <button className={Styles.ActionBtn}>
                     Sign Up Today—Limited Seats Available
                   </button>
                 </div> */}
          </div>
        </div>
      </section>

      {/* Testimonials start */}
      <section style={{ background: "#f4f9ff" }} className={Styles.Margin_new}>
        <div>
          <h1 className={Styles.Heading}>
            <span className={Styles.Font_Rajdhani}>
              {" "}
              Hear From Our Students
            </span>
          </h1>
        </div>

        <Testimonial
          TestmonialRef={TestmonialRef}
          Testimonials_Model={Testimonials_Model}
        />
        <div className={Styles.Center}>
          <button className={Styles.ActionBtn} onClick={() => Scroll()}>
            Join the Test Today
          </button>
        </div>
      </section>
      {/* Testimonials end */}

      {/* FAQs satrt */}

      <section style={{ background: "#ffffff" }} className=".Faqs">
        <div className={Styles.Margin_new}>
          <div className="container-fluid mt-5 mb-5">
            <div className="card-body_Faq">
              <div className={Styles.Form_Heading}>
                <h1 className="">
                  Frequently Asked{" "}
                  <span style={{ color: "#0b3eff" }}>Questions</span>
                </h1>
                <p style={{ textAlign: "center" }}>
                  Got Questions? We’ve Got Answers!
                </p>
              </div>
              <div className="FAQ_ALL">
                {FAQS_TLAT.map((faq, index) => {
                  return (
                    <AccordionItem
                      key={index}
                      active={active}
                      handleToggle={handleToggle}
                      faq={faq}
                    />
                  );
                })}
              </div>
              {/* <div className={Styles.Center}>
                <button className={Styles.ActionBtn} onClick={() => Scroll()}>
                  Join the Test Today
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* FAQs end */}

      <section className={Styles.Footer_Top}>
        <div>
          <div
            style={{ display: "flex", flexDirection: "column" }}
            className={Styles.LowFotterBanner}
          >
            <h1 className={"Font_Rajdhani"}>
              Don’t Miss Out on This Unique Opportunity!
            </h1>
            <p>
              Take a free T-LAT Test today and move one step closer to studying
              abroad.
            </p>
          </div>
          <div>
            <button className={"Font_Rajdhani"} onClick={() => Scroll()}>
              Register Now—Limited Seats Available
            </button>
          </div>
        </div>
      </section>

      {createSec ? (
        <div
          id="CreatContact"
          style={{ width: "100%" }}
          className={"overlay-note middle-hand w100 BookDemo Payment_landing"}
        >
          <div className="container" id="booking-container">
            <h1 style={{ margin: "0", padding: "0" }}>
              Register Now for T-LAT !
            </h1>
            <p style={{ margin: "0", padding: "0" }}>
              (Testifyi Language Assessment Test)
            </p>
            <div onClick={() => handleCancel()} className="closeBtn_Book">
              <span>
                <IoIosCloseCircle />
              </span>
            </div>
            <form
              style={{ marginTop: "25px" }}
              id="appointment-form"
              onSubmit={handleSubmit}
              className="Form_Appointment landingPayment"
            >
              <div>
                <div className="form-group">
                  <label for="First_Name">First Name</label>
                  <input
                    id="First_Name"
                    type="text"
                    name="First_Name"
                    value={DetailsForm?.First_Name}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div>

              <div>
                <div className="form-group">
                  <label for="Last_Name">Last Name</label>
                  <input
                    id="Last_Name"
                    type="text"
                    name="Last_Name"
                    value={DetailsForm?.Last_Name}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div>

              <div>
                <div className="form-group">
                  <label for="EmailAddress">Email Address</label>
                  <input
                    id="EmailAddress"
                    type="email"
                    name="EmailAddress"
                    value={DetailsForm?.EmailAddress}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div>

              <div>
                <div className="form-group">
                  <label for="phone">Phone No</label>
                  <input
                    type="number"
                    id="phone"
                    name="PhoneNo"
                    value={DetailsForm?.PhoneNo}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div>
              <div>
                {error || Auth.error ? (
                  <p style={{ color: "red" }}> {error || Auth.error}</p>
                ) : success ? (
                  <p style={{ color: "green" }}>
                    {"Please Wait — we are redirecting you to the TLAT test!"}
                  </p>
                ) : (
                  ""
                )}
              </div>

              <div className="Fotter_payment">
                <div>
                  {/* <img
                          src="/assets/image/pay_methods_branding.png"
                          alt="pay_methods_branding"
                        /> */}
                </div>
                <div className="Book_A_demo_btn">
                  <button type="submit" disabled={loading}>
                    {loading ? "Loading..." : "TAKE A TEST"}
                  </button>
                </div>
              </div>
              {/* <div
                      className="Safe_Secure"
                      style={{ padding: "0", margin: "0" }}
                    >
                      <p style={{ paddingTop: "8px", margin: "0" }}>
                        <span>
                          <AiFillSafetyCertificate />
                        </span>
                        <span>Safe and Secure Payments 100%.</span>
                      </p>
                    </div> */}
            </form>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* Footer start */}
      <footer className={Styles.Footer}>
        {/* {BookADemoActive ? (
        <BookADemo setBookADemoActive={setBookADemoActive} />
      ) : (
        ""
      )} */}
        <div>
          <div>
            <div>
              <img
                onClick={() => Navigate("/")}
                src="/assets/image/Logos/Testifyi_logo1.jpg"
                alt="logo"
              />
              <p>
                Facilitating students acquire perfect-fit education placements
                that ultimately changes their lives!
              </p>

              {/* <p>Contact No : +91 92891 92873</p> */}
            </div>
            <hr className={Styles.Hr1} />
            <div>
              <h3>My Profile</h3>
              <p onClick={() => Navigate("/signup", { replace: true })}>
                Create Account
              </p>
              <p onClick={() => Navigate("/web-login", { replace: true })}>
                Login Now
              </p>
              <p onClick={() => Navigate("/contact-us")}>Contact Us</p>{" "}
              <p onClick={() => Navigate("/about-us")}>About Us</p>
            </div>
            <hr className={Styles.Hr1} />
            <div>
              <h3>Important Links</h3>
              <p onClick={() => Navigate("/Course")}>Our Courses</p>
              {/* <p onClick={() => Navigate("/course")}>Courses</p> */}
              {/* <p onClick={() => setBookADemoActive(true)}>Book A Demo</p> */}
              <p onClick={() => Navigate("/dashboard")}>Dashboard</p>
              <p onClick={() => Navigate("/terms-and-conditions")}>
                Terms And Conditions
              </p>
              <p onClick={() => Navigate("/privacy-policy")}>Privacy Policy</p>
            </div>
            <hr className={Styles.Hr1} />
            <div>
              <h3>Contact Us</h3>
              <p style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                <span style={{ color: "white" }}>
                  <IoHomeOutline />{" "}
                </span>

                <span style={{ fontSize: "14px" }}>
                  Address : 1409-1412, 14th Floor, 38, Ansal Tower, Nehru Place,
                  New Delhi, Delhi 110019
                </span>
              </p>

              <p style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                <span style={{ color: "white" }}>
                  <IoIosCall />
                </span>
                <span style={{ fontSize: "14px" }}>+91 92891 92873</span>
              </p>
              <p style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                <span style={{ color: "white" }}>
                  <FaMapMarkedAlt />{" "}
                </span>

                <span style={{ fontSize: "14px" }}>
                  Map :{" "}
                  <a
                    href="https://maps.app.goo.gl/74ufjPk837JUPDcq8"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    Locate Us{" "}
                  </a>
                </span>
              </p>
              {/* <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.702078508757!2d77.25045209999999!3d28.5486732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce35adb1e9e1f%3A0xf8cd70d1f67432d3!2sTestifyi%20-%20IELTS%2FPTE%2FDUOLINGO%20%26%20General%20English%20Platform!5e0!3m2!1sen!2sin!4v1735282947328!5m2!1sen!2sin"
                    width="100%"
                    height="250"
                    style={{border:"0"}}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe> */}
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "-20px",
                }}
              >
                Follow Us :{" "}
                <p style={{ display: "flex", gap: "8px", color: "white" }}>
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/testifyi.india?igsh=c3ZpN2N2ZDg4cWVm"
                      )
                    }
                  >
                    <PiInstagramLogoBold />
                  </span>
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.facebook.com/testifyi.india?mibextid=LQQJ4d"
                      )
                    }
                  >
                    <RiFacebookFill />
                  </span>
                  {/* <span>
                <TiSocialLinkedin />{" "}
              </span><FaMapMarkedAlt />
              <span>
                <BiLogoTwitter />
              </span> */}
                </p>{" "}
              </p>

              {/* <p onClick={() => Navigate("/signup", { replace: true })}>
                Create Account
              </p>
              <p onClick={() => Navigate("/login", { replace: true })}>
                Login Now
              </p> */}
            </div>
          </div>

          <div>
            <hr className={Styles.Hr2} />
            <p onClick={() => Navigate("/")}>
              @ 2024 Testifyi.com All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
      {/* Footer end */}
    </>
  );
}
